import { render, staticRenderFns } from "./CatSubAssets.vue?vue&type=template&id=45b84e2c&scoped=true&"
import script from "./CatSubAssets.vue?vue&type=script&lang=js&"
export * from "./CatSubAssets.vue?vue&type=script&lang=js&"
import style0 from "./CatSubAssets.vue?vue&type=style&index=0&id=45b84e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b84e2c",
  null
  
)

export default component.exports